import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { customerLinks, adminLinks } from "config/links";
import "styles/modules/navigation.module.scss";
import permissions, { checkPermissions } from "config/permissions";
import { setCurrentSuperTabPath } from "../../actions/tabs";
import Control from "./Control";
import ReactSVG from "react-svg";
import { get } from "lodash";
import { withTranslation } from "react-i18next";
import { redirectToFCS } from "helpers";

function mapStateToProps(state) {
    return {
        // isIdentityEnabled: checkPermissions(permissions.AdminGrantOperations.action_manage_access),
        // identity: state.user.identity.host,
        currentSuperTabPath: state.tabs.currentSuperTabPath,
        staticBlocks: state.staticBlocks.blocks,
        permissionsObject: state.user.permissionsObject,
    };
}

const getSortedTabs = (tabs, type) => {
    let sortedTabs = [];
    const item = tabs.blocks.find(tab => tab.type === type);
    if (item && item.tabs) {
        sortedTabs = item && item.tabs;
    } else {
        if (type === "mainNavigation") {
            sortedTabs = customerLinks;
        }
        if (type === "adminNavigation") {
            sortedTabs = adminLinks;
        }
    }
    return sortedTabs.sort((a, b) => {
        return a.order - b.order;
    });
};

const Navigation = props => {
    const {
        // isIdentityEnabled,
        location,
        setCurrentSuperTabPath,
        currentSuperTabPath,
        staticBlocks,
        permissionsObject,
        t,
    } = props;

    const tabs = useMemo(() => {
        const primaryTabs = staticBlocks && staticBlocks.find(block => block.code === "PAGE_ROUTE_CUSTOM");
        if (primaryTabs && primaryTabs.blocks && Array.isArray(primaryTabs.blocks) && primaryTabs.blocks.length > 0) {
            return primaryTabs;
        }
        const defaultTabs = staticBlocks && staticBlocks.find(block => block.code === "PAGE_ROUTE_DEFAULT");
        if (defaultTabs && defaultTabs.blocks && Array.isArray(defaultTabs.blocks) && defaultTabs.blocks.length > 0) {
            return defaultTabs;
        }
    }, [staticBlocks]);

    const mainTabs = useMemo(() => {
        return getSortedTabs(tabs, "mainNavigation");
    }, [tabs]);

    const adminTabs = useMemo(() => {
        return getSortedTabs(tabs, "adminNavigation");
    }, [tabs]);

    const superTabs = [...mainTabs.map(link => link.name), ...adminTabs.map(link => link.name)];

    useEffect(() => {
        const currentPath = location && location.pathname;
        const isSuperTab = superTabs.find(tab => {
            // do not match "appeal" as a supper tab if some appeal is opened via /appeals/:id path
            if (tab === "appeal" && currentPath.startsWith("/appeals")) {
                return;
            }
            return currentPath.startsWith(`/${tab}`);
        });
        if (isSuperTab) {
            setCurrentSuperTabPath(currentPath);
        }

        // config to handle when page init with some active tab
        // mark appropriate superTab as active in such case (and provide correct path for it)
        // /appeals/12345/ => superTab /appeal (special case)
        // /order/12345/ => superTab /orders
        if (!isSuperTab && !currentSuperTabPath) {
            const splittedCurrentPath = currentPath.split("/");
            const activeTabPath = splittedCurrentPath && splittedCurrentPath[1];
            // appeals is special case, active tab is plural "appeals" and supertab is single "appeal";
            if (activeTabPath && activeTabPath !== "search") {
                // search could not be as an active tab
                if (activeTabPath === "appeals") {
                    setCurrentSuperTabPath(`/appeal`);
                } else {
                    // otherwise simple add "s" to the path end for proper superTab path
                    setCurrentSuperTabPath(`/${activeTabPath}s`);
                }
            }
        }
    }, [location]);

    useEffect(() => {
        if (!currentSuperTabPath) {
            // try to set based on redirect
            const defaultRedirect = tabs && tabs.blocks.find(block => block.type === "redirect");
            if (defaultRedirect && defaultRedirect.redirect) {
                setCurrentSuperTabPath(defaultRedirect.redirect);
            }
            // if no redirect available => fallback to first visible tab
            if (!defaultRedirect) {
                const defaultFirstTab = mainTabs.find(tab => {
                    const isPermissionOk = permissionsObject[tab.permission];
                    if (tab.show && isPermissionOk) {
                        return tab;
                    }
                });
                if (defaultFirstTab) {
                    setCurrentSuperTabPath(`/${defaultFirstTab.name}`);
                }
            }
        }
    }, [mainTabs]);

    const renderTabs = tab => {
        // const permission = get(permissions, item.permission);
        // const isPermissionOk = checkPermissions(permission);
        // TODO: remove once permission is available
        const isPermissionOk = permissionsObject[tab.permission];
        if (!tab.show || !isPermissionOk) {
            return null;
        }
        return (
            <Control item={{ ...tab, link: `/${tab.name}` }} currentSuperTabPath={currentSuperTabPath} key={tab.name} />
        );
    };

    return (
        <aside>
            <div>
                <div className="logo-container">
                    <div className="container-menu">
                        <ReactSVG src="/data/svg/logo.svg" />
                    </div>
                </div>
                <div className="sections-block">{mainTabs.map(renderTabs)}</div>
                {permissionsObject["DocumentOperations.view_extRedirect"] && (
                    <div className="sections-block">
                        <div
                            onClick={() => {
                                redirectToFCS(null);
                            }}
                            className="box"
                            title={t("redirect.fcs")}
                        >
                            <ReactSVG
                                svgClassName="grid-icon identity-icon-white"
                                src={`/data/svg/navigation/redirect_fcs.svg`}
                            />
                        </div>
                    </div>
                )}
            </div>
            <div className="sections-block">{adminTabs.map(renderTabs)}</div>
        </aside>
    );
};

export default withRouter(connect(mapStateToProps, { setCurrentSuperTabPath })(withTranslation()(Navigation)));
